import React from 'react';
import '../less/expressEnergy.less';
import hero_img from '../img/hero_img.png';
import Advantages from '../../../../auxiliary-components/shared/AdvantagesBlock';
import FilesForDownloadNew from "../../../../auxiliary-components/shared/FilesForDownloadNew";
import CalculatorNew from '../../../../auxiliary-components/CalculatorNew';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import { Preloader } from 'MWComponents';
import hero_data from '../enums/hero_data.json';
import { getUrl } from "utils/corploansUrl";
import advantagesItemsData from '../enums/advantages_items.json';
import Hero from '../../../../auxiliary-components/shared/HeroBlock';

export default function template() {
    const page = 'express-energy-new';
    const model = this.getModel();

    const openCorploansLink = getUrl();

    const imagesMap = {
      advantages_img_1,
      advantages_img_2,
      advantages_img_3
    };

    const handlersMap = {
      openCorploansLink: openCorploansLink
    };

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        href: handlersMap[hero_data.link.href],
      },
    };

    const advantagesItems = advantagesItemsData.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    return (
        <div className="express-energy-new">
          <Hero
            data={heroData}
            img={hero_img}
          />
          <div className="content">
            <div>
              <Advantages
                items={advantagesItems}
                title={'EXPRESS_ENERGY_NEW_ADVANTAGES_TITLE'}
              />
              <div className="funds-use">
                <div className="container">
                  <div className="funds-use__title">{this.l10n('EXPRESS_ENERGY_NEW_FUNDS_USE_TITLE')}</div>
                  <ul className="funds-use__list">
                    <li>{this.l10n('EXPRESS_ENERGY_NEW_FUNDS_USE_LIST_01')}</li>
                    <li>{this.l10n('EXPRESS_ENERGY_NEW_FUNDS_USE_LIST_02')}</li>
                    <li>{this.l10n('EXPRESS_ENERGY_NEW_FUNDS_USE_LIST_03')}</li>
                    <li>{this.l10n('EXPRESS_ENERGY_NEW_FUNDS_USE_LIST_04')}</li>
                    <li>{this.l10n('EXPRESS_ENERGY_NEW_FUNDS_USE_LIST_05')}</li>
                  </ul>
                </div>
              </div>
            </div>
            {model.creditSum ? (
              <CalculatorNew model={model} type={"express-energy"} link={openCorploansLink} {...this.props} currentName={model.currentName}/>
            ) : <Preloader />}
            <FilesForDownloadNew
              widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
              loader={this.state.loader}
            />
          </div>
        </div>
    );
}
